<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" class="mt-28px" />

    <!-- 점검정보  -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 점검정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>측정일</div>
          <p v-if="isPrint" class="print-input">{{ form.측정일 }}</p>
          <date-selector v-else v-model="form.측정일" :readonly="board.readonly" />
        </div>
        <div>
          <div>측정기관</div>
          <p v-if="isPrint" class="print-input">{{ form.측정기관 }}</p>
          <ml-input v-else v-model="form.측정기관" class="w-full" />
        </div>
        <div>
          <div>측정부서</div>
          <p v-if="isPrint" class="print-input">{{ form.측정부서 }}</p>
          <ml-input v-else v-model="form.측정부서" class="w-full" />
        </div>
        <div>
          <div>특이사항</div>
          <p v-if="isPrint" class="print-input">{{ form.특이사항 }}</p>
          <ml-input v-else v-model="form.특이사항" class="w-full" />
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="mt-28px" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";

export default {
  components: {
    FileUploadModule,
    DateSelector,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      allCheck: false,
      form: {
        stdInfo: {},
        측정일: "",
        측정기관: "",
        측정부서: "",
        특이사항: "",
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
